export default __webpack_public_path__ + "static/media/KZ.Т.12.2512.bbba464b.svg";